import { hseSiteConfig } from '../config/hse/site.config';

export const environment = {
  production: false,
  x_api_key: 'SW7ijp2I13DScTLmo6JvWsiBWdiwmXWa',
  apiUrl: 'https://api-hse-qa.kozaca.com.ar/api',
  apiUrl_photo: 'https://api-hse-qa.kozaca.com.ar',
  portalUrl: 'https://pacientes-hse-qa.kozaca.com.ar',
  auth: {
    clientId: '019ff750-24d8-7226-872a-fa503648cf45',
    clientSecret: 'OucCGehBrIisyBpFGp1lEatPjiXh2XXPk7KpnPOo',
  },
  siteConfig: hseSiteConfig,
};
